<script setup lang="ts">
import DateInput from '@/components/dateInput/DateInput.vue';
import FormError from '@/components/formError/FormError.vue';

defineProps<{
  block: App.Surveys.Data.SurveyBlockData;
  errors?: Record<string, string>;
  value?: string;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
}>();

function handleValueUpdate(value) {
  emit('update:modelValue', value);
}
</script>

<template>
  <div class="flex w-full flex-col gap-1.5">
    <DateInput
      :modelValue="value"
      inline
      @update:modelValue="(value) => handleValueUpdate(value)"
    />
    <FormError v-if="errors?.value">{{ errors.value }}</FormError>
  </div>
</template>
